<script lang="ts">
    import {Select, Button, Icon, Toast} from 'svelma';
    import type IPresentable from "../application/interfaces/IPresentable.ts";
    import type {Writable} from "svelte/store";
    import Filter from "../application/models/Filter";
    import {_} from 'svelte-i18n';

    export let placeholder: string;
    export let dataArray: Array<IPresentable>;
    export let filter: Writable<Filter>;
    export let store;
    export let additionalText : string = "";
    export let hasCounter : boolean = false;
    let value;

    function resetSelect(){
        value = "";
        $filter[store] = null;
        Toast.create({ message: $_('menubar.message'), type: 'is-primary',position: 'is-top' });
    }

    $: {if (value !== undefined && value !== "") {$filter[store] = value;}}
</script>

<div class="column">
    <div class="columns is-gapless">
        <div class="column">
            <Select bind:selected={value} placeholder={placeholder} size="is-small" rounded expanded>
                {#each dataArray as item, i}
                    <option value={item.id}>
                        {#if hasCounter}
                            {i+1}. {additionalText} :
                        {/if}
                        {item.name}
                    </option>
                {/each}
            </Select>
        </div>
        <div class="column is-narrow has-text-info">
            {#if value !== ""}
                <Button type="is-danger" on:click={resetSelect} size="is-small" rounded>
                    <Icon pack="fa" size="is-small" icon="times"/>
                </Button>
            {/if}
        </div>
    </div>
</div>